import { render, staticRenderFns } from "./SesionMaternidadperfil.vue?vue&type=template&id=c92fe3cc"
import script from "./SesionMaternidadperfil.vue?vue&type=script&lang=js"
export * from "./SesionMaternidadperfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports